



























import Vue from "vue";
import { getObjPropFromString } from "@/utility/Formatter";

export default Vue.extend({
    data() {
        return {};
    },
    props: {
        /** Title */
        cardTitle: {
            type: String,
        },

        /** Cols size of the left column */
        leftCols: {
            default: "auto",
        },

        /** Cols size of the right column */
        rightCols: {},

        keys: {
            type: Array,
            required: true,
        },

        object: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getObjPropFromString,
    },
});
